// extracted by mini-css-extract-plugin
export default {"root":"Lists_root__qS56b","headLine":"Lists_headLine__6b9A5","title":"Lists_title__6PgGz"};